<template lang="pug">
  .report
    PCheckbox(v-model="reportOptions.isHour" label="Mostrar informação em horas/minutos (hh:mm)")
    PCheckbox(v-model="reportOptions.untilDate" label="Mostrar o saldo geral até a data final selecionada")
    PCheckbox(v-model="reportOptions.fired" :label="`Considerar ${$wp('employee')} demitidos`")

    .button
      PButton(color="success" size="md" @click="generate('excel')" :loading="loading" :disabled="!valid") gerar excel

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        isHour: false,
        untilDate: false,
        fired: false
      }
    }
  },
  computed: {
    entity () {
      if (this.reportInfo.entity === 'employees') return 'employee'
      return this.reportInfo.entity
    }
  },
  methods: {
    async generate (typeReport) {
      this.loading = true

      let result

      try {
        result = await this.$API.R10.save({
          entity: this.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          ...this.reportOptions,
          startDate: moment(this.reportInfo.periodData.startDate).format('MM-DD-YY'),
          endDate: moment(this.reportInfo.periodData.endDate).format('MM-DD-YY')
        })
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;

  .options {
    display: grid;
    grid-template-columns: 1fr 0.6fr max-content;
    grid-column-gap: 30px;

    .option {
      display: grid;
      grid-auto-columns: 1fr 1fr;

      > span {
        grid-column: 1/3;
      }
    }
  }
  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
